module.exports = __webpack_public_path__ + "img/logo.134fd38d.png";